var exports = {
  "rT": "dialogSubtitle__nAe8k0",
  "uW": "section__8U-L0O",
  "bV": "sectionHeader__XXlEFE",
  "t4": "chevronIcon__RkgrVJ",
  "f7": "sectionIcon__zHRY_q",
  "Gf": "sectionTitle__E-dCLZ",
  "F0": "expandedContent__LLDmGJ",
  "mZ": "connectorLine__X3Hke0",
  "Kl": "matchList__sDz-jb",
  "N0": "matchItem__EFNM7w",
  "aN": "matchLink__fyzLMr",
  "aR": "repositoryName__lL8Ibp",
  "Mz": "repositoryAvatar__GqHGHC",
  "k6": "repositoryAvatarFallback__Wf57bu",
  "O": "avatarInitial__kX0ojG",
  "j2": "licenseBadge__lkKXBZ",
  "p$": "emptyState__CASE3w",
};

module.exports = exports;
